import getSearchRedirects from 'services/api/search-redirects'
import makeActionCreator from 'services/utility/makeActionCreator'

export const API_SUCCESS = 'API_SUCCESS'
export const API_FAIL = 'API_FAIL'

export const sRedirectAPISuccess = makeActionCreator(API_SUCCESS, 'data')
export const sRedirectAPIFail = makeActionCreator(API_FAIL, 'data')

// eslint-disable-next-line max-len
export const laodSearchRedirects = () => dispatch => getSearchRedirects().then(data => dispatch(sRedirectAPISuccess(data)))



// WEBPACK FOOTER //
// ./services/app-state/search/actions/index.js